/** Self-registration (also used for forgot-password flow). */
export const CRE_SELF_REGISTER_URL = "https://bo.medilis.ai/?register=1";

/**
 * Extension asks the CRE page for the current SESSION snapshot (no silent mint).
 * Name retained for wire compatibility; response is CRE_DESKTOP_AGENT_SESSION only.
 */
export const CRE_DESKTOP_AGENT_AUTH_REQUEST = "CRE_DESKTOP_AGENT_AUTH_REQUEST";

/** Canonical page → extension MedMic session snapshot. */
export const CRE_DESKTOP_AGENT_SESSION = "CRE_DESKTOP_AGENT_SESSION";

/** Extension → page: disconnect MedMic only (no MSAL logout). */
export const CRE_EXTENSION_DISCONNECT_REQUEST =
  "CRE_EXTENSION_DISCONNECT_REQUEST";

/** Extension → page: authenticated API request failed auth for a committed generation. */
export const CRE_EXTENSION_AUTH_FAILURE = "CRE_EXTENSION_AUTH_FAILURE";

/** BroadcastChannel name for multi-tab MedMic auth sync. */
export const MEDMIC_AUTH_BROADCAST_CHANNEL = "medmic-auth";

/** localStorage key for cross-tab refresh lease. */
export const MEDMIC_REFRESH_LEASE_KEY = "medmic_refresh_lease_v1";
